export enum SSP {
  pixels_commerce_grid = 'Pixels (commerce grid)',
  ix = 'Index Exchange',
  pubmatic = 'Pubmatic'
}